




































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import PicView from "@/components/pic-preview.vue";
@Component({
  components: {
    PicView,
  },
})
export default class SzsxDanxuan extends Vue {
  @Prop()
  private question;
  @Prop()
  private index;
  @Prop()
  private filters;
  private get answer() {
    return this.$store.state.moniAnswers[this.index];
  }
  private ifShowPic: boolean = false;
  private index2Alpha: any[] = [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
  ];
  @Watch("answer.reply", { deep: true, immediate: true })
  private replyChange(value) {
    this.$forceUpdate();
  }
  /**
   * @description 判断是否选中
   */
  private ifSelect(oi) {
    if (!this.answer || !this.answer["reply"]) {
      return false;
    }
    return oi === this.answer["reply"][0];
  }
  /**
   * @description 选择某个
   */
  private selectThis(o) {
    this.$emit("select", o);
  }
}
